import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do PT clinics get more direct-access patients?",
    "a": "Condition-specific pages — back pain, knee, shoulder, post-op, sports — each rank separately. Patients search by what hurts. Pages that match the condition convert."
  },
  {
    "q": "Is cash-pay PT marketing different?",
    "a": "Yes — cash-pay positions as performance, outcomes, and access. Insurance positions as coverage and convenience. We tailor both — or just the one you focus on."
  },
  {
    "q": "Should PT clinics run Google Ads?",
    "a": "Yes for cash-pay, post-op, and sports performance — patient values justify CPCs. For insurance-only practices, SEO carries it."
  },
  {
    "q": "Do you market specialty PT (pelvic floor, vestibular, sports)?",
    "a": "Yes — specialties outperform generic PT on search. Each specialty gets a dedicated page that ranks faster than broad PT terms."
  },
  {
    "q": "How do we drive referrals from doctors and surgeons?",
    "a": "Referrer-facing pages plus a clean clinical site that surgeons trust. The same SEO that wins direct patients also wins referral credibility."
  }
];

export const Route = createFileRoute("/physical-therapy-marketing-colorado")({
  head: () =>
    industryMarketingHead("Physical Therapy Clinic", "physical therapy clinic", "physical-therapy-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Physical Therapy Clinic"}
      industryLower={"physical therapy clinic"}
      slug={"physical-therapy-marketing-colorado"}
      subheadline={"We help Colorado physical therapy clinics — cash-pay and insurance — fill the schedule with patients who actually want to do the work."}
      painPoints={["Doctor referrals dropped and you can't predict the schedule","Cash-pay marketing feels different and yours doesn't translate","Patients shop on insurance directories that send the worst-fit clients"]}
      serviceDescriptions={{
        seo: "Rank for physical therapy, sports rehab, post-op, dry needling, manual therapy, and every PT service in every Colorado market.",
        googleMaps: "Own 'physical therapy near me' in the Map Pack with patient outcome reviews.",
        webDesign: "Condition-specific pages — back pain, knee, shoulder, post-op — with therapist bios and online booking.",
        ppc: "Profitable Google Ads for cash-pay PT, sports performance, and post-op recovery searches.",
        geoAi: "Get cited when patients ask ChatGPT 'best physical therapist in Denver' or 'sports PT near me'.",
        socialMedia: "Therapist-led education content that builds authority and converts cash-pay patients.",
      }}
      testimonial={{"quote":"Cash-pay schedule went from half-full to two-week wait. The condition pages convert way better than our old generic site.","role":"Owner & Lead PT","city":"Colorado Springs"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Physical therapy marketing in Colorado Springs","description":"Cash-pay and sports PT across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Physical therapy marketing in Denver","description":"Compete in Denver's saturated PT market."},{"to":"/boulder-digital-marketing","label":"Physical therapy marketing in Boulder","description":"Premium and performance PT for Boulder's active population."}]}
    />
  ),
});
